// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit'; // Importe la fonction `configureStore` de Redux Toolkit pour créer un store Redux avec une configuration simplifiée.
import { persistStore, persistReducer } from 'redux-persist'; // Importe les fonctions `persistStore` et `persistReducer` pour configurer la persistance de l'état avec `redux-persist`.
import storage from 'redux-persist/lib/storage'; // Utilise `redux-persist` pour choisir le type de stockage (ici `localStorage` du navigateur) pour persister l'état.
import userReducer from './userSlice'; // Importe le réducteur `userReducer` depuis le fichier `userSlice`. Ce réducteur gère l'état de l'utilisateur.

// Définition de la configuration de persistance pour `redux-persist`.
const persistConfig = {
  key: 'root',
  storage,
};

// Crée une version persistante de `userReducer` en utilisant la configuration de persistance définie.
const persistedReducer = persistReducer(persistConfig, userReducer);

// Crée le store Redux avec Redux Toolkit en configurant `user: persistedReducer` comme réducteur.
// Ici, `user` est la clé du store pour l'état de l'utilisateur, et `persistedReducer` applique la persistance à ce réducteur.
const store = configureStore({
  reducer: {
    user: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE','persist/PURGE']
      }
    })
});

export const persistor = persistStore(store);
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
